import { Checkbox, Select, Textarea } from "@mantine/core";
import type { UseFormReturnType } from "@mantine/form";
import type { MouseEventHandler } from "react";
import type { ReplacementFormValues } from "./replacePathologistFormTypes";

interface CandidateOption {
  value: string;
  label: string;
}

interface ReplacePathologistFieldsProps {
  form: UseFormReturnType<ReplacementFormValues>;
  candidateOptions: CandidateOption[];
  candidateDropdownOpened: boolean;
  onCandidateMouseDown: MouseEventHandler<HTMLInputElement>;
  onCandidateDropdownOpen: () => void;
  onCandidateDropdownClose: () => void;
  activeReviewAcknowledgementRequired: boolean;
  staleConflictActive: boolean;
  reviewedUpdatedAssignment: boolean;
  onReviewedUpdatedAssignmentChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

export default function ReplacePathologistFields({
  form,
  candidateOptions,
  candidateDropdownOpened,
  onCandidateMouseDown,
  onCandidateDropdownOpen,
  onCandidateDropdownClose,
  activeReviewAcknowledgementRequired,
  staleConflictActive,
  reviewedUpdatedAssignment,
  onReviewedUpdatedAssignmentChange,
}: ReplacePathologistFieldsProps) {
  return (
    <>
      <Select
        label="Replacement pathologist"
        placeholder="Choose a pathologist"
        data={candidateOptions}
        searchable
        required
        allowDeselect={false}
        dropdownOpened={candidateDropdownOpened}
        onMouseDown={onCandidateMouseDown}
        onDropdownOpen={onCandidateDropdownOpen}
        onDropdownClose={onCandidateDropdownClose}
        comboboxProps={{
          position: "bottom-start",
          offset: 8,
          withinPortal: true,
        }}
        nothingFoundMessage="No eligible pathologists found"
        {...form.getInputProps("replacementPathologistId")}
      />

      <Textarea
        label="Reason (optional)"
        description="If provided, this reason becomes part of the permanent assignment history."
        placeholder="Explain why this case is being reassigned"
        minRows={3}
        maxLength={500}
        {...form.getInputProps("reason")}
      />

      {activeReviewAcknowledgementRequired && (
        <Checkbox
          label="I acknowledge that an active review will be interrupted."
          {...form.getInputProps("acknowledgeActiveReview", {
            type: "checkbox",
          })}
        />
      )}

      {staleConflictActive && (
        <Checkbox
          label="I reviewed the updated current assignment."
          checked={reviewedUpdatedAssignment}
          onChange={onReviewedUpdatedAssignmentChange}
        />
      )}
    </>
  );
}
